import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { authQueries } from '@/api';
import { AppRoute } from '@/constants';
import { useUserStore } from '@/stores';
import { UserRole } from '@/types';

import { Loader } from './Loader';

type PrivateRouteProps = {
    children: React.ReactNode;
    roles?: UserRole[];
};

const ALL_ROLES: UserRole[] = ['super_admin', 'admin', 'script_writer', 'manager'];

export const PrivateRoute = ({ children, roles = ALL_ROLES }: PrivateRouteProps) => {
    const { user } = useUserStore();

    const { data: userData, isFetching } = useQuery({
        ...authQueries.checkUser(),
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (userData) {
            useUserStore.getState().setUser(userData);
        }
    }, [userData]);

    if (isFetching) {
        return <Loader />;
    }

    if (!user || !user.role) {
        return <Navigate to={AppRoute.Login} />;
    }

    if (!roles.includes(user.role)) {
        return <Navigate to={AppRoute.Forbidden} />;
    }

    return children;
};
